const LOCAL_GLOBAL = '@AgrogerWeb';

const storage = {
  user: `${LOCAL_GLOBAL}:user`,
  token: `${LOCAL_GLOBAL}:token`,
  regAtividade: `${LOCAL_GLOBAL}:sobre`,
  colheita: `${LOCAL_GLOBAL}:colheita`,
  medidaPadrao: `${LOCAL_GLOBAL}:medidaPadrao`,
  regMdo: `${LOCAL_GLOBAL}:regMdo`,
  tutorial: `${LOCAL_GLOBAL}:tutorial`,
  folhaBuscarColaborador: `${LOCAL_GLOBAL}:folhaBuscarColaborador`,
  filtersFinancial: `${LOCAL_GLOBAL}:financialFilters`,
  filtersFinancialSearch: `${LOCAL_GLOBAL}:filtersFinancialSearch`,
  filtersFinancialPeriod: `${LOCAL_GLOBAL}:filtersFinancialPeriod`,
  filtersFinancialPagination: `${LOCAL_GLOBAL}:filtersFinancialPagination`,
  filtersFinancialPaginationConta: `${LOCAL_GLOBAL}:filtersFinancialPaginationConta`,
  openFinanceOcultarValores: `${LOCAL_GLOBAL}:openFinanceOcultarValores`,
  talhoesSort: `${LOCAL_GLOBAL}:talhoesSort`,
  vendasSortBy: `${LOCAL_GLOBAL}:vendasSortBy`,
  vendasSortOrder: `${LOCAL_GLOBAL}:vendasSortOrder`,
  fazendaAtivaId: `${LOCAL_GLOBAL}:fazendaAtivaId`,
  whatsappSetupDismissed: `${LOCAL_GLOBAL}:whatsappSetupDismissed`,
};

const resetStorages = () => {
  localStorage.removeItem(storage.user);
  localStorage.removeItem(storage.token);
  localStorage.removeItem(storage.regAtividade);
  localStorage.removeItem(storage.colheita);
  localStorage.removeItem(storage.medidaPadrao);
  localStorage.removeItem(storage.regMdo);
  localStorage.removeItem(storage.tutorial);
  localStorage.removeItem(storage.filtersFinancialSearch);
  localStorage.removeItem(storage.filtersFinancialPeriod);
  localStorage.removeItem(storage.filtersFinancial);
  localStorage.removeItem(storage.filtersFinancialPagination);
  localStorage.removeItem(storage.filtersFinancialPaginationConta);
  localStorage.removeItem(storage.vendasSortBy);
  localStorage.removeItem(storage.vendasSortOrder);
  localStorage.removeItem(storage.fazendaAtivaId);

  Object.keys(localStorage).forEach((key) => {
    if (key.startsWith(`${storage.filtersFinancialPaginationConta}_`)) {
      localStorage.removeItem(key);
    }
  });
};

const resetRegAtividade = () => {
  localStorage.removeItem(storage.regAtividade);
};

export { LOCAL_GLOBAL, storage, resetStorages, resetRegAtividade };
